import { createApp } from 'vue';
import App from './ProductCart.vue';
import {useTippy} from '../../../_helpers/vue-tippy';

document.querySelectorAll('[data-product-cart]').forEach((el) => {
    const app = createApp(App);
    app.config.globalProperties.$config = JSON.parse(el.dataset.productCart);
    useTippy(app);
    app.mount(el);
});
